import React, { useCallback, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { useAddUserOrganization } from "./userServices";
import OrganizationAutoComplete from "./OrganizationAutoComplete";

const useStyles = makeStyles(theme => ({
  form: {
    marginTop: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

const AddUserOrganizationDialog = props => {
  const { open, onCancel, onOk, onError, user } = props;
  const classes = useStyles();

  const [selectedOrganization, setSelectedOrganization] = useState("");

  const addUserOrganization = useAddUserOrganization();
  const handleApply = useCallback(async () => {
    try {
      await addUserOrganization.mutateAsync({
        resourceIds: {
          userId: user.userId,
          organizationId: selectedOrganization,
        },
      });
      setSelectedOrganization("");
      onOk();
    } catch (err) {
      onError(err);
    }
  }, [user.userId, selectedOrganization, addUserOrganization, onOk, onError]);

  const handleClose = useCallback(() => {
    onCancel();
  }, [onCancel]);

  const handleOrganizationSelected = useCallback(organizationId => {
    setSelectedOrganization(organizationId);
  }, []);

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={handleClose}
      aria-labelledby="add-organization-dialog-title"
    >
      <DialogTitle id="add-organization-dialog-title">
        Add User to Organization
      </DialogTitle>
      <DialogContent>
        <Paper>
          <Box className={classes.form}>
            <Grid spacing={2} container>
              <Grid item xs={12}>
                <OrganizationAutoComplete
                  label="Select Organization"
                  value={selectedOrganization}
                  onChange={handleOrganizationSelected}
                />
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleApply} color="primary">
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddUserOrganizationDialog;
